import paisavalaLogo from "../../assets/Image/logo.png";
import chequeLogo from "../../assets/SubscriptionImage/Cheque.png";
import generalLogo from "../../assets/SubscriptionImage/General.png";
import payrollLogo from "../../assets/SubscriptionImage/Payroll.png";
import timecardLogo from "../../assets/SubscriptionImage/TimeCard.png";
import inventoryLogo from "../../assets/SubscriptionImage/Inventory.png";
import LotteryLogo from "../../assets/SubscriptionImage/Lottery.png";
import GasLogo from "../../assets/SubscriptionImage/Gas.png";
import PosLogo from "../../assets/SubscriptionImage/Pos.png";
import SpendLogo from '../../assets/SubscriptionImage/expense.png';
import SalesLogo from '../../assets/SubscriptionImage/Sale.png';
import LegalLogo from '../../assets/SubscriptionImage/LegalApp.png';
import AssetsLogo from "../../assets/img/logo-image/assets.png"
import EcommerceLogo from "../../assets/SubscriptionImage/e-com.png"
import CameraLogo from '../../assets/SubscriptionImage/CameraIcon.jpg'

const generateSettingsSubmenu = (features = []) => {

  const defaultSettings = [

    { name: "Manage Store/Users", path: "/manage-users", access: ["Store Owner"] },
    { name: "Customer Insights", path: "/customer-insights", access: ["Store Owner"] },
    { name: "Staff Sales Activity", path: "/staff-sales-activity", access: ["Store Owner", "Store Admin", "Store Manager"] },
    { name: "Store Settings", path: "/manage-settings", access: ["Store Owner"] },
    { name: "My Subscriptions", path: "/store-information", access: ["Store Owner"] },
  ];

  const additionalSettings = [];

  if (features.includes("Sales", "Sales + Inventory")) {
    additionalSettings.push(
      { name: "Vendor Management", path: "/manage-vendor" },


    );
  }

  if (features.includes("Lottery")) {
    additionalSettings.push(
      { name: "Store Settings", path: "/manage-settings" }
    );
  }

  if (features.includes("Spends Tracking")) {
    additionalSettings.push(
      { name: "Vendor Management", path: "/manage-vendor" },
      { name: "Store Settings", path: "/manage-settings" }
    );
  }

  if (features.includes("General Ledger")) {
    additionalSettings.push(
      { name: "Store Settings", path: "/manage-settings" }
    );
  }

  const uniqueSettings = [];
  const paths = new Set();

  [...defaultSettings, ...additionalSettings].forEach(setting => {
    if (!paths.has(setting.path)) {
      paths.add(setting.path);
      uniqueSettings.push(setting);
    }
  });

  return uniqueSettings;
};

export const appConfigs = {
  paisa_vara: {
    key: 'paisa_vara',
    permissionModule: null, // maps to the Permission Group catalog module
    name: 'PV',
    displayName: 'Paisavara',
    logo: paisavalaLogo,
    feature: null,
    initialRoute: '/',
  },

  cheque_pal: {
    key: 'cheque_pal',
    permissionModule: 'chequeService', // maps to the Permission Group catalog module
    name: 'Cheque',
    displayName: 'Cheque',
    logo: chequeLogo,
    feature: 'Cheque',
    initialRoute: '/cheque-form',
    code: "PERM_CHEQUE",
    menuItems: [
      {
        name: "Dashboard",
        path: "/cheque-dashboard",
        access: ["all"],
        permissions: "PERM_CHEQUE_DASHBOARD"
      },
      {
        name: "Cheque Form",
        path: "/cheque-form",
        access: ["all"],
        permissions: "PERM_CHEQUE_FORM"
      },
      {
        name: "Cheque History",
        path: "/cheque-history",
        access: ["all"],
        permissions: "PERM_CHEQUE_HISTORY"
      },
      {
        name: "Settings",
        submenu: [

          { name: "Manage Configuration", path: "/manage-configuration", permissions: "PERM_CHEQUE_MANAGE_CONFIGURATION" }
        ],
        access: ["all"]
      }
    ],
  },




  timecard_app: {
    key: 'timecard_app',
    permissionModule: 'timeCardService', // maps to the Permission Group catalog module
    name: 'Timecard',
    displayName: 'Timecard',
    logo: payrollLogo,
    feature: 'Timecard',
    initialRoute: '/employee-enrollment',
    code: 'PERM_TIMECARD',
    menuItems: [
      {
        name: "Dashboard",
        path: "/timecard-dashboard",
        access: ["all"],
        permissions: "PERM_TIMECARD_DASHBOARD"
      },
      {
        name: "Register/Attendance ",
        path: "/attendance-register",
        access: ["all"],
        permissions: "PERM_TIMECARD_ATTENDANCE_REGISTER"
      },
      {
        name: "Employee Enrollment",
        path: "/employee-enrollment",
        access: ["all"],
        permissions: "PERM_EMPLOYEE_ENROLLMENT"
      },
      // {
      //   name: "Biometric Logs",
      //   path: "/biometric-logs",
      //   access: ["all"],
      //   // permissions: "PERM_BIOMETRIC_PAYROLL"
      // },
      {
        name: "Logs",
        path: "/employee-logs",
        access: ["all"],
        permissions: "PERM_EMPLOYEE_LOG"
      },
      {
        name: "Settings",
        submenu: [

          { name: "Manage Configuration", path: "/manage-configuration", permissions: "PERM_TIMECARD_MANAGE_CONFIGURATION" }
        ],
        access: ["all"]
      }
    ],
  },

  payroll_app: {
    key: 'payroll_app',
    permissionModule: 'payrollService', // maps to the Permission Group catalog module
    name: 'Payroll',
    displayName: 'Payroll',
    logo: timecardLogo,
    feature: 'Payroll',
    code: 'PERM_PAYROLL',
    initialRoute: '/employee-payroll',
    menuItems: [
      {
        name: "Dashboard",
        path: "/payroll-dashboard",
        access: ["all"],
        permissions: "PERM_PAYROLL_DASHBOARD"
      },
      {
        name: "Pay Employees",
        path: "/employee-payroll",
        access: ["all"],
        permissions: "PERM_MANUAL_PAYROLL"
      },
      

      {
        name: "Settings",
        submenu: [

          { name: "Manage Configuration", path: "/manage-configuration", permissions: "PERM_PAYROLL_MANAGE_CONFIGURATION" },
          { name: "Manage Settings", path: "/manage-settings", permissions: "PERM_PAYROLL_MANAGE_SETTINGS" }
        ],
        access: ["all"]
      }
    ],
  },

  sales_app: {
    key: 'sales_app',
    permissionModule: 'invoiceService', // maps to the Permission Group catalog module
    name: 'Sales',
    displayName: 'Sales',
    logo: SalesLogo,
    feature: ['Sales', 'Sales + Inventory'],
    initialRoute: '/quick-Invoice',
    code: 'PERM_SALES',
    menuItems: [
      {
        name: "Quick Invoice",
        path: "/quick-Invoice",
        access: ["all"],
        permissions: "PERM_QUICK_INVOICE"
      },
      {
        name: "Retail Invoice",
        path: "/retail-Invoice",
        access: ["all"],
        permissions: "PERM_RETAILS_INVOICE"
      },
      {
        name: "Wholesale Invoice",
        path: "/sales-Invoice",
        access: ["all"],
        permissions: "PERM_WHOLESALE_INVOICE"
      },
      {
        name: "Business Report",
        path: "/Report",
        access: ["all"],
        permissions: "PERM_BUSINESS_REPORT"
      },
      {
        name: "Staff Sales Activity",
        path: "/staff-sales-activity",
        access: ["Store Owner", "Store Admin", "Store Manager"]
      },
      {
        name: "History Invoices",
        submenu: [
          { name: "Quick Invoices", path: "/invoice-pos-history", permissions: "PERM_QUICK_HISTORY" },
          { name: "Retail Invoices", path: "/invoice-retail-history", permissions: "PERM_RETAIL_HISTORY" },
          { name: "Ecom Invoices", path: "/invoice-ecom-history", permissions: "PERM_RETAIL_HISTORY" },
          { name: "Wholesale Invoices", path: "/invoice-sales-history", permissions: "PERM_WHOLESALE_HISTORY" },
        ],
        access: ["all"]
      },
      {
        name: "Settings",
        submenu: [

          { name: "Manage Configuration", path: "/manage-configuration", permissions: "PERM_SALE_MANAGE_CONFIGURATION" },
          { name: "Manage Vendor", path: "/manage-vendor", permissions: "PERM_SALE_MANAGE_VENDOR" }
        ],
        access: ["all"]
      }
    ],
  },

  inventory_app: {
    key: 'inventory_app',
    permissionModule: 'productService', // maps to the Permission Group catalog module
    name: 'Inventory',
    displayName: 'Inventory',
    logo: inventoryLogo,
    feature: ['Inventory', 'Sales + Inventory'],
    initialRoute: '/product',
    code: 'PERM_INVENTORY',
    menuItems: [
      {
        name: "Dashboard",
        path: "/inventory-dashboard",
        access: ["all"],
        permissions: "PERM_INVENTORY_DASHBOARD"
      },
      {
        name: "Product",
        path: "/product",
        access: ["all"],
        permissions: "PERM_PRODUCT"
      },
      {
        name: "Stock Transfer",
        path: "/inventory-stock-transfer",
        access: ["all"],
        permissions: "PERM_PRODUCT"
      },
      // {
      //   name: "Inventory",
      //   path: "/inventory",
      //   access: ["all"],
      //   permissions: "PERM_PRODUCT_INVENTORY"
      // },
      // {
      //   name: "Stock History",
      //   path: "/stock-history",
      //   access: ["all"],
      //   permissions: "PERM_MANAGE_STOCK"
      // },
      {
        name: "Purchase",
        submenu: [

          { name: "RFQ Management", path: "/inventory-rfq", permissions: "PERM_INVENTORY_MANAGE_CONFIGURATION" },
          { name: "Quotation Management", path: "/inventory-quotation-management", permissions: "PERM_INVENTORY_MANAGE_VENDOR" },
          { name: "Purchase Order Mangement", path: "/inventory-po", permissions: "PERM_INVENTORY_MANAGE_DEPARTMENTS" },
          // { name: "Manage Expense Type", path: "/manage-expense-type", permissions: "PERM_INVENTORY_MANAGE_EXPENSE_TYPE" }
        ],
        access: ["all"]
      },
      {
        name: "Settings",
        submenu: [

          { name: "Manage Configuration", path: "/manage-configuration", permissions: "PERM_INVENTORY_MANAGE_CONFIGURATION" },
          { name: "Manage Vendor", path: "/manage-vendor", permissions: "PERM_INVENTORY_MANAGE_VENDOR" },
          { name: "Manage Product Category", path: "/product-category", permissions: "PERM_PRODUCT_CATEGORY" }
        ],
        access: ["all"]
      }
    ],
  },

  lottery_app: {
    key: 'lottery_app',
    permissionModule: 'lotteryService', // maps to the Permission Group catalog module
    name: 'Lottery',
    displayName: 'Lottery',
    logo: LotteryLogo,
    feature: 'Lottery',
    initialRoute: '/lottery-operations',
    code: "PERM_LOTTERY",
    menuItems: [
      {
        name: "Dashboard",
        path: "/lottery-dashboard",
        access: ["all"],
        permissions: "PERM_LOTTERY_DASHBOARD"
      },
      {
        name: "Lottery Operations",
        path: "/lottery-operations",
        access: ["all"],
        permissions: "PERM_LOTTERY"
      },
      {
        name: "Daily Lottery",
        path: "/daily-lottery",
        access: ["all"],
        permissions: "PERM_DAILY_LOTTERY"
      },
      {
        name: "Staff Sales Activity",
        path: "/staff-sales-activity",
        access: ["Store Owner", "Store Admin", "Store Manager"]
      }
    ],
  },

  gas_app: {
    key: 'gas_app',
    permissionModule: 'gasService', // maps to the Permission Group catalog module
    name: 'Gas',
    displayName: 'Gas',
    logo: GasLogo,
    feature: 'Gas',
    initialRoute: '/gas-invoice',
    code: "PERM_GAS",
    menuItems: [
      {
        name: "Dashboard",
        path: "/gas-dashboard",
        access: ["all"],
        permissions: "PERM_GAS_DASHBOARD"
      },
      {
        name: "Gas Invoice",
        path: "/gas-invoice",
        access: ["all"],
        permissions: "PERM_GAS_INVOICE"
      },
      {
        name: "Gas Tax Settings",
        path: "/gas-tax-settings",
        access: ["all"],
        permissions: "PERM_GAS_TAX_SETTINGS"
      },
      {
        name: "Gas Settings",
        path: "/gas-settings",
        access: ["all"],
        permissions: "PERM_GAS_SETTINGS"
      },
      {
        name: "Settings",
        submenu: [

          { name: "Manage Configuration", path: "/manage-configuration", permissions: "PERM_GAS_MANAGE_CONFIGURATION" },
        ],
        access: ["all"]
      }
    ],
  },

  pos_app: {
    key: 'pos_app',
    permissionModule: 'posService', // maps to the Permission Group catalog module
    name: 'POS',
    displayName: 'POS',
    logo: PosLogo,
    feature: 'Pos',
    initialRoute: '/pos-dashboard',
    code: 'PERM_POS',
    menuItems: [
      {
        name: "Dashboard",
        path: "/pos-dashboard",
        access: ["all"],
        permissions: "PERM_POS_DASHBOARD"
      },
      {
        name: "Transactions",
        path: "/pos-invoices",
        access: ["all"],
        permissions: "PERM_POS_TRANSACTION"
      },
      // {
      //   name: "Product Settings",
      //   path: "/pos-settings",
      //   access: ["all"],
      //   permissions: "PERM_PRODUCT_SETTING"
      // },
      {
        name: "Settings",
        submenu: [

          { name: "Manage Configuration", path: "/manage-configuration", permissions: "PERM_POS_MANAGE_CONFIGURATION" },
        ],
        access: ["all"]
      }
    ],
  },

  spends_tracking_app: {
    key: 'spends_tracking_app',
    permissionModule: 'utilService', // maps to the Permission Group catalog module
    name: 'Spend Tracking',
    displayName: 'Spends Tracking',
    logo: SpendLogo,
    feature: 'Spends Tracking',
    initialRoute: '/expense',
    code: 'PERM_SPENDS_TRACKING',
    menuItems: [
      {
        name: "Expense",
        path: "/expense",
        access: ["all"],
        permissions: "PERM_SPENDS_EXPENSE"
      },
      {
        name: "Purchase",
        path: "/purchase",
        access: ["all"],
        permissions: "PERM_SPENDS_PURCHASE"
      },
      {
        name: "Invoices",
        submenu: [
          { name: "Expense Invoices", path: "/expense-invoice", permissions: "PERM_SPENDS_EX-INVOICE" },
          { name: "Purchase Invoices", path: "/purchase-invoice", permissions: "PERM_SPENDS_PUR-INVOICE" },
          { name: "Pay Invoices", path: "/pay-invoice", permissions: "PERM_PAY_INVOICE" },
        ],
        access: ["all"]
      },
      {
        name: "Settings",
        submenu: [

          { name: "Manage Configuration", path: "/manage-configuration", permissions: "PERM_SPENDS_MANAGE_CONFIGURATION" },
          { name: "Manage Vendor", path: "/manage-vendor", permissions: "PERM_SPENDS_MANAGE_VENDOR" },
          { name: "Manage Settings", path: "/manage-settings", permissions: "PERM_SPENDS_MANAGE_SETTINGS" }
        ],
        access: ["all"]
      }
    ],
  },

  gl_app: {
    key: 'gl_app',
    permissionModule: 'generalLedgerService', // maps to the Permission Group catalog module
    name: 'General Ledger',
    displayName: 'General Ledger · Owners Ledger',
    logo: generalLogo,
    feature: 'General Ledger',
    initialRoute: '/Report',
    code: 'PERM_GENERAL',
    menuItems: [
      {
        name: "Dashboard",


        path: "/Report",
        // submenu: [
        //   { name: "Add Invoice", path: "/addInvoice", permissions: "PERM_GENERALLEDGER_ADD_INVOICE" },
        //   { name: "Pay Invoice", path: "/pay-invoice", permissions: "PERM_PAY_INVOICE" }
        // ],
        access: ["all"]
      },
      {
        name: "Owners Ledger",
        path: "/owners-ledger",
        permissions: "PERM_GENERALLEDGER_OWNER_DISTRIBUTION",
        access: ["all"]
      },
      {
        name: "Deposits",
        submenu: [
          { name: "ATM", path: "/ATM", permissions: "PERM_GENERALLEDGER_ATM" },
          { name: "Bank", path: "/Bank", permissions: "PERM_GENERALLEDGER_BANK" },
          { name: "Other Income", path: "/OtherIncome", permissions: "PERM_GENERALLEDGER_OTHER_INCOME" }
        ],
        access: ["all"]
      },
      {
        name: "Sales Tax",
        path: "/SalesTax",
        access: ["all"],
        permissions: "PERM_GENERALLEDGER_SALES_TAX"
      },
      {
        name: "Ledger",
        submenu: [
          { name: "Owner Distribution", path: "/OwnerDist", permissions: "PERM_GENERALLEDGER_OWNER_DISTRIBUTION" },
          { name: "Bank Ledger", path: "/bankLedger", permissions: "PERM_GENERALLEDGER_BANK_LEDGER" },
          { name: "Cash Ledger", path: "/cashLedger", permissions: "PERM_GENERALLEDGER_CASH_LEDGER" }
        ],
        access: ["all"]
      },
      {
        name: "Settings",
        submenu: [

          { name: "Manage Configuration", path: "/manage-configuration", permissions: "PERM_GL_MANAGE_CONFIGURATION" },
          { name: "Manage Settings", path: "/manage-settings", permissions: "PERM_GL_MANAGE_SETTINGS" }
        ],
        access: ["all"]
      }
    ],
  },
  legal_app: {
    key: 'legal_app',
    permissionModule: 'legalManagementService', // maps to the Permission Group catalog module
    name: 'Legal Manage',
    displayName: 'Legal Manager',
    logo: LegalLogo,
    feature: 'Legal Manage',
    initialRoute: '/legal-dashboard',
    code: 'PERM_LEGAL',
    menuItems: [
      {
        name: "Dashboard",
        path: "/legal-dashboard",
        access: ["all"],
        permissions: "PERM_LEGAL_DASHBOARD"
      },
      {
        name: "Templates",
        path: "/legal-templates",
        access: ["all"],
        permissions: "PERM_LEGAL_TEMPLATES"
      },
      // {
      //   name: "Policies",
      //   path: "/legal-policies",
      //   access: ["all"]
      // },
      {
        name: "Legal Documents",
        path: "/legal-documents",
        access: ["all"],
        permissions: "PERM_LEGAL_DOCUMENTS",
        // access: ["Store Manager", "Store Employee" , "Store Owner"],
        permissions: "PERM_LEGAL_DOCUMENTS"
      },
      // {
      //   name: "Document Preview",
      //   path: "/document-preview/:id",
      //   // access: ["all"],
      //       access: ["Store Manager", "Store Employee"],
      //   permissions:"PERM_LEGAL_DOCUMENTS"
      // },
      {
        name: "Signed Documents",
        path: "/signed-documents",
        access: ["all"],
        permissions: "PERM_LEGAL_SIGNED_DOCUMENTS"
      },
      {
        name: "Document Assigning",
        path: "/legal-document-signing",
        access: ["all"],
        permissions: "PERM_LEGAL_DOCUMENT_SIGNING"
      },
      {
        name: "Audit Logs",
        path: "/legal-audit-logs",
        access: ["all"],
        permissions: "PERM_LEGAL_AUDIT_LOGS"
      },
      {
        name: "Settings",
        submenu: [
          { name: "Manage Configuration", path: "/manage-configuration", permissions: "PERM_SPENDS_MANAGE_CONFIGURATION" },
          { name: "Manage Settings", path: "/manage-settings", permissions: "PERM_SPENDS_MANAGE_SETTINGS" }
        ],
        access: ["all"]
      }
    ],
  },
  asset_management_app: {
    key: 'asset_management_app',
    permissionModule: 'assetService', // maps to the Permission Group catalog module
    name: 'Asset Management App',
    displayName: 'Asset Management',
    logo: AssetsLogo,
    feature: 'Asset Management',
    initialRoute: '/asset-management-dashboard',
    code: "PERM_ASSET",
    menuItems: [
      {
        name: "Dashboard",
        path: "/asset-management-dashboard",
        access: ["all"],
        permissions: "PERM_ASSET_DASHBOARD"
      },

      {
        name: "Inventory",
        path: "/asset-inventory",
        access: ["all"],
        permissions: "PERM_ASSET_INVENTORY"
      },
      {
        name: "Requests",
        access: ["all"],
        submenu: [
          {
            name: "Asset Request",
            path: "/asset-request",
            permissions: "PERM_ASSET_REQUEST"
          },
          {
            name: "Request List",
            path: "/asset-request-list",
            permissions: "PERM_ASSET_REQUEST_LIST"
          },
          {
            name: "Allocation",
            path: "/asset-allocation",
            permissions: "PERM_ASSET_ALLOCATION"
          }
        ]
      },
      {
        name: "Maintanance",
        submenu: [
          {
            name: "Maintenance",
            path: "/asset-maintenance",
            // access: ["all"],
            permissions: "PERM_ASSET_MAINTENANCE"
          },
          {
            name: "Maintenance Cost",
            path: "/asset-maintenance-cost",
            // access: ["all"],
            permissions: "PERM_ASSET_MAINTENANCE_COST"
          },
        ],
        access: ["all"]
      },
      {
        name: "Purchase",
        submenu: [
          { name: "RFQ Management", path: "/rfq-management", permissions: "PERM_ASSET_RFQ_MANAGEMENT" },
          { name: "Quotation Management", path: "/quotation-management", permissions: "PERM_ASSET_QUOTATION_MANAGEMENT" },
          { name: "Purchase Order Management", path: "/purchase-order-management", permissions: "PERM_ASSET_PURCHASE_ORDER_MANAGEMENT" },
          // { name: "Asset Procurement Dashboard", path: "/asset-procurement-dashboard", permissions: "PERM_ASSET_PROCUREMENT_DASHBOARD" },

        ],
        access: ["all"]
      },
      {
        name: "Settings",
        submenu: [
          { name: "Manage Configuration", path: "/manage-configuration", permissions: "PERM_SPENDS_MANAGE_CONFIGURATION" },
          { name: "Manage Vendor", path: "/manage-vendor", permissions: "PERM_SPENDS_MANAGE_VENDOR" },
          { name: "Manage Settings", path: "/manage-settings", permissions: "PERM_SPENDS_MANAGE_SETTINGS" },
          {
            name: "Manage Category",
            path: "/asset-category",
            access: ["all"],
            permissions: "PERM_ASSET_CATEGORY"
          },
        ],
        access: ["all"]
      }
    ],
  },

  //E-commerce 
  ecommerce_app: {
    key: 'ecommerce_app',
    permissionModule: 'ecomService', // maps to the Permission Group catalog module
    name: 'E-Commerce',
    displayName: 'E-Commerce',
    logo: EcommerceLogo,
    feature: 'Ecommerce',
    initialRoute: '/ecommerce/dashboard',
    code: 'PERM_ECOMMERCE',
    menuItems: [
      {
        name: "Dashboard",
        path: "/ecommerce/dashboard",
        access: ["all"],
        permissions: "PERM_ECOM_DASHBOARD"
      },
      {
        name: "My Websites",
        path: "/ecommerce/my-websites",
        access: ["all"],
        permissions: "PERM_ECOM_MY_WEBSITES"
      },
      {
        name: "Orders",
        path: "/ecommerce/orders",
        access: ["all"],
        permissions: "PERM_ECOM_MY_WEBSITES"
      },
      {
        name: "Visitor Analytics",
        path: "/ecommerce/visitor-analytics",
        access: ["all"],
        permissions: "PERM_ECOM_MY_WEBSITES"
      }
    ],
  },

  monitoring_app: {
    key: 'monitoring_app',
    permissionModule: 'mointerService', // maps to the Permission Group catalog module
    name: 'Monitoring App',
    displayName: 'Monitoring',
    logo: CameraLogo,
    feature: 'Monitoring',
    initialRoute: '/monitor/groups',
    code: '',
    menuItems: [
      {
        name: 'Dashboard',
        path: '/monitor/dashboard',
        access: ['all'],
        permissions: ''
      },
      {
        name: 'Monitor Manage',
        path: '/monitor/cameras',
        access: ['all'],
        permissions: ''
      },
      {
        name: 'Alert Rules',
        path: '/monitor/alert-rules',
        access: ['all'],
        permissions: ''
      },
      {
        name: 'Live Monitor',
        path: '/monitor/live-monitor',
        access: ['all'],
        permissions: ''
      },
      {
        name: 'Events',
        path: '/monitor/events',
        access: ['all'],
        permissions: ''
      },
      {
        name: 'Media',
        path: '/monitor/media',
        access: ['all'],
        permissions: ''
      },
      {
        name: 'Audit Records',
        path: '/monitor/audit',
        access: ['all'],
        permissions: ''
      }
    ]
  },
};

// permissionGroupCheck is an optional { isConfigured, canAccessPage } pair
// from useMyPermissions - see getFilteredApps above for why this overrides
// rather than ANDs with the legacy checks once a member is in a group.
// Page-level restriction only engages for apps that map to a permission
// module (app.permissionModule) AND whose group has at least one
// page-specific grant configured for that module - see canAccessPage's own
// comment for the backward-compat fallback to module-wide access.
export const getAccessibleMenuItems = (appKey, allowedFeatures = [], permissions = [], userRole = null, permissionGroupCheck = null) => {
  const menuItems = getMenuItemsForApp(appKey);
  const app = appConfigs[appKey];
  const permissionModule = app?.permissionModule;
  const isConfigured = !!permissionGroupCheck?.isConfigured;
  const canAccessPage = permissionGroupCheck?.canAccessPage;

  const checkPermission = (permissionCode) => {
    if (!permissions || !permissionCode) return true;
    if (permissions.includes("all")) return true;
    return permissions.includes(permissionCode);
  };

  const hasPageGroupAccess = (path) => {
    if (!isConfigured || !permissionModule || !canAccessPage || !path) return true;
    return canAccessPage(permissionModule, path, "view");
  };

  const filterMenuItems = (items) => {
    return items.filter(item => {

      if (!isMenuItemAllowed(item.name, allowedFeatures, appKey)) {
        return false;
      }

      // Role-based access check FIRST (before permission check)
      if (item.access && !item.access.includes("all")) {
        if (!userRole || !item.access.includes(userRole)) {
          return false; // Block if role not in access list
        }
      }

      if (item.permissions && !checkPermission(item.permissions)) {
        return false;
      }

      if (!hasPageGroupAccess(item.path)) {
        return false;
      }

      if (item.submenu) {
        const filteredSubmenu = item.submenu.filter(subItem => {
          const hasRoleAccess = !subItem.access ||
            subItem.access.includes("all") ||
            (userRole && subItem.access.includes(userRole));

          const hasPermissionAccess = !subItem.permissions ||
            checkPermission(subItem.permissions);

          return hasRoleAccess && hasPermissionAccess && hasPageGroupAccess(subItem.path);
        });

        if (filteredSubmenu.length === 0) {
          return false;
        }

        item.submenu = filteredSubmenu;
      }

      return true;
    });
  };

  return filterMenuItems(menuItems);
};

export const getSingleAccessibleRoute = (appKey, allowedFeatures = [], permissions = [], userRole = null) => {
  const accessibleItems = getAccessibleMenuItems(appKey, allowedFeatures, permissions, userRole);

  let totalAccessibleRoutes = 0;
  let singleRoute = null;

  accessibleItems.forEach(item => {
    if (item.path) {
      totalAccessibleRoutes++;
      singleRoute = item.path;
    }

    if (item.submenu) {
      totalAccessibleRoutes += item.submenu.length;
      if (item.submenu.length === 1) {
        singleRoute = item.submenu[0].path;
      }
    }
  });

  if (totalAccessibleRoutes === 1) {
    return singleRoute;
  }

  return null;
};

export const getEnhancedInitialRoute = (appKey, allowedFeatures = [], permissions = [], userRole = null) => {
  const singleRoute = getSingleAccessibleRoute(appKey, allowedFeatures, permissions, userRole);

  if (singleRoute) {
    return singleRoute;
  }

  const accessibleItems = getAccessibleMenuItems(appKey, allowedFeatures, permissions, userRole);
  const defaultInitialRoute = getInitialRouteForApp(appKey);

  const hasAccessToDefault = accessibleItems.some(item => {
    if (item.path === defaultInitialRoute) return true;
    if (item.submenu) {
      return item.submenu.some(subItem => subItem.path === defaultInitialRoute);
    }
    return false;
  });

  if (hasAccessToDefault) {
    return defaultInitialRoute;
  }

  for (const item of accessibleItems) {
    if (item.path) {
      return item.path;
    }
    if (item.submenu && item.submenu.length > 0) {
      return item.submenu[0].path;
    }
  }

  return defaultInitialRoute;
};
export const getAppInfo = (appKey) => {
  return appConfigs[appKey] || appConfigs.paisa_vara;
};

export const getInitialRouteForApp = (appKey) => {
  return getAppInfo(appKey).initialRoute;
};

export const getLogoForApp = (appKey) => {
  return getAppInfo(appKey).logo;
};

export const getAppNameForApp = (appKey) => {
  const app = getAppInfo(appKey);

  // Check if screen width is 1280x800 or similar smaller screens
  if (window.innerWidth <= 1366 && window.innerWidth >= 1200) {
    const shortNames = {
      'paisa_vara': 'PV',
      'cheque_pal': 'Cheque',
      'timecard_app': 'Time',
      'payroll_app': 'Payroll',
      'sales_app': 'Sales',
      'inventory_app': 'Inventory',
      'lottery_app': 'Lottery',
      'gas_app': 'Gas',
      'pos_app': 'POS',
      'spends_tracking_app': 'Spends',
      'gl_app': 'GL',
      'legal_app': 'Legal',
      '/document-preview': 'legal_app',
      'asset_app': 'Asset',
      'ecommerce_app': 'E-Com',
    };
    return shortNames[appKey] || app.displayName;
  }

  return app.displayName;
};

export const getMenuItemsForApp = (appKey) => {
  if (appKey === 'paisa_vara') {

    const featuresString = localStorage.getItem("allowedFeatures");
    const features = featuresString ? JSON.parse(featuresString) : [];

    const settingsSubmenu = generateSettingsSubmenu(features);

    return [
      // {
      //   name: "Dashboard",
      //   path: "/owner-dashobaord",
      //   access: ["Store Owner"]
      // },
      {
        name: "Manage Apps",
        path: "/",
        access: ["all"],
      },
      // {
      //   name: "Transaction ",
      //   path: "/transaction",
      //   access: ["Store Owner"],
      // },

      {
        name: "Business Overview",
        path: "/business-overview",
        access: ["Store Owner"],
      },

      {
        name: "Business Report",
        path: "/Report",
        access: ["all"],
      },

      {
        name: "Staff Sales Activity",
        path: "/staff-sales-activity",
        access: ["Store Owner", "Store Admin", "Store Manager"],
      },
    ];
  }

  return getAppInfo(appKey).menuItems || [];
};

export const isPathValidForApp = (path, appKey) => {
  const menuItems = getMenuItemsForApp(appKey);
  return menuItems.some(item => {
    if (item.path === path) return true;
    if (item.submenu) return item.submenu.some(subItem => subItem.path === path);
    return false;
  });
};

export const isAppAccessible = (appKey, features) => {
  const app = getAppInfo(appKey);
  if (!app) return false;

  if (appKey === 'paisa_vara') return true;

  if (app.feature === null) return true;
  if (Array.isArray(app.feature)) {
    return app.feature.some(f => features.includes(f));
  }
  return features.includes(app.feature);
};

export const detectAppFromPath = (path) => {

  const pathToAppMap = {};

  Object.entries(appConfigs).forEach(([appKey, appConfig]) => {

    if (appKey === 'paisa_vara') {
      const featuresString = localStorage.getItem("allowedFeatures");
      const features = featuresString ? JSON.parse(featuresString) : [];
      const menuItems = getMenuItemsForApp(appKey);

      menuItems.forEach(item => {
        if (item.path) pathToAppMap[item.path] = appKey;
        if (item.submenu) {
          item.submenu.forEach(subItem => {
            pathToAppMap[subItem.path] = appKey;
          });
        }
      });
    } else {

      if (appConfig.menuItems) {
        appConfig.menuItems.forEach(item => {
          if (item.path) pathToAppMap[item.path] = appKey;
          if (item.submenu) {
            item.submenu.forEach(subItem => {
              pathToAppMap[subItem.path] = appKey;
            });
          }
        });
      }
    }
  });

  if (pathToAppMap[path]) return pathToAppMap[path];

  const pathPatterns = {
    '/cheque': 'cheque_pal',
    '/gas': 'gas_app',
    '/lottery': 'lottery_app',
    '/pos': 'pos_app',
    '/expense': 'spends_tracking_app',
    '/purchase': 'spends_tracking_app',
    '/payroll': 'payroll_app',
    '/timecard': 'timecard_app',
    '/employee': 'timecard_app',
    '/inventory': 'inventory_app',
    '/product': 'inventory_app',
    '/stock': 'inventory_app',
    '/quick-Invoice': 'sales_app',
    '/invoice': 'sales_app',
    '/sales-Invoice': 'sales_app',
    '/retail-Invoice': 'sales_app',
    '/ATM': 'gl_app',
    '/Bank': 'gl_app',
    '/OwnerDist': 'gl_app',
    '/SalesTax': 'gl_app',
    '/Ledger': 'gl_app',
    '/legal': 'legal_app',
    '/document-preview': 'legal_app',
    '/asset': 'asset_management_app',
    '/ecommerce': 'ecommerce_app',
    '/camera': 'camera_app',
  };

  for (const [pattern, appKey] of Object.entries(pathPatterns)) {
    if (path.startsWith(pattern)) return appKey;
  }

  return 'paisa_vara';
};

export const getAllApps = () => {
  return Object.values(appConfigs);
};
// permissionGroupCheck is an optional { isConfigured, can } pair from
// useMyPermissions. Once a member's been placed in a Permission Group, that
// group is meant to be the source of truth for apps it maps to (via
// app.permissionModule) - not an extra AND on top of the old PERM_* codes,
// which are often stale. So when configured, the legacy `permissions` code
// check is skipped for any app with a permissionModule, and the group's own
// view-access check decides instead. Apps with no permissionModule, or
// users who haven't been put in a group yet, keep the old behavior.
export const getFilteredApps = (allowedFeatures = [], permissions = [], permissionGroupCheck = null) => {
  const isConfigured = !!permissionGroupCheck?.isConfigured;
  const canAccessModule = permissionGroupCheck?.can;

  return Object.values(appConfigs).filter(app => {
    const hasFeatureAccess =
      app.feature === null ||
      (Array.isArray(app.feature)
        ? app.feature.some(f => allowedFeatures.includes(f))
        : allowedFeatures.includes(app.feature));

    const skipLegacyCodeCheck = isConfigured && !!app.permissionModule;

    const hasPermissionAccess =
      skipLegacyCodeCheck ||
      !app.code || permissions.includes("all") || permissions.includes(app.code);

    const hasGroupPermission =
      !app.permissionModule || !canAccessModule || canAccessModule(app.permissionModule, "view");

    return hasFeatureAccess && hasPermissionAccess && hasGroupPermission;
  });
};
export const isMenuItemAllowed = (itemName, allowedFeatures, currentApp) => {

  if (itemName === "Settings" || itemName === "Statistics") {
    return true;
  }

  if (!allowedFeatures || !allowedFeatures.length) {
    return currentApp === 'paisa_vara';
  }

  if (itemName === "Pay Invoice" &&
    (currentApp === "gl_app" || currentApp === "spends_tracking_app")) {
    return true;
  }

  const menuToFeatureMap = {
    "Lottery": "Lottery",
    "Reports": "Report",
    "Sales": ["Sales", "Sales + Inventory"],
    "P & L": ["Sales", "Sales + Inventory"],
    "Gas": "Gas",
    "Gas Invoice": "Gas",
    "Gas Tax Settings": "Gas",
    "Gas Settings": "Gas",
    "House Charges": "Gas",
    "Expense": "Spends Tracking",
    "General Ledger": "General",
    "Payroll": "Payroll",
    "Cheque Form": "Cheque",
    "Inventory": ["Inventory", "Sales + Inventory"],
    "Pos": "Pos",
    "Manage Vendor": ["Sales + Inventory", "Spends Tracking"],
    "Manage Settings": ["Sales + Inventory", "Spends Tracking", "General"],
    "Manage Departments": "Spends Tracking",
    "Manage Expense Type": "Spends Tracking",
    "Other Income Type": "General",
    "legal_app": "Legal Manage",
    "Legal Documents": "Legal Manage",
    "Signed Documents": "Legal Manage",
    "Products": "E-Commerce",
    "Orders": ["E-Commerce", "Ecommerce"],
    "Customers": "E-Commerce",
  };

  const requiredFeatures = menuToFeatureMap[itemName];
  if (!requiredFeatures) {
    return true;
  }

  if (Array.isArray(requiredFeatures)) {
    return requiredFeatures.some(feat => allowedFeatures.includes(feat));
  }
  return allowedFeatures.includes(requiredFeatures);
};

export { generateSettingsSubmenu };
